export type PlRow = {
  _id?: string
  userName?: string
  companyMasterWinInr?: number
  companyMasterCommissionInr?: number
  companyMasterNetInr?: number
}

export type PlTotals = {
  companyMasterWinInrSum?: number
  companyMasterCommissionInrSum?: number
  companyMasterNetInrSum?: number
}

/** Lab selectedUser may be a string id or `{ _id }` object. */
export function normalizeSelectedUserId(
  selectedUser: string | { _id?: string } | null | undefined,
): string {
  if (selectedUser == null) return 'all'
  if (typeof selectedUser === 'string') {
    const s = selectedUser.trim()
    return s || 'all'
  }
  const id = String(selectedUser._id ?? '').trim()
  return id || 'all'
}

/** Accept Session-API `{ data, sumOfAmounts }` or legacy `{ results, totals }`. */
export function parsePlResponse(body: unknown): { rows: PlRow[]; totals: PlTotals } {
  if (body == null) return { rows: [], totals: {} }
  if (Array.isArray(body)) return { rows: body as PlRow[], totals: {} }

  const obj = body as {
    data?: PlRow[] | unknown
    sumOfAmounts?: PlTotals | PlTotals[]
    results?: PlRow[]
    totals?: PlTotals
  }

  if (Array.isArray(obj.data)) {
    const sums = obj.sumOfAmounts
    const totals = Array.isArray(sums) ? (sums[0] ?? {}) : (sums ?? {})
    return { rows: obj.data, totals }
  }

  return {
    rows: Array.isArray(obj.results) ? obj.results : [],
    totals: obj.totals ?? (Array.isArray(obj.sumOfAmounts) ? obj.sumOfAmounts[0] : obj.sumOfAmounts) ?? {},
  }
}
